import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import DashboardMessages from "../../components/Shop/DashboardMessages";

const ShopInboxPage = () => {
  return (
    <div className="shop-management-page">
    <DashboardHeader />
    <div className="shop-management-layout">
      <div className="shop-management-sidebar-slot">
        <DashboardSideBar active={2} />
      </div>
      <main className="shop-management-main-panel">
        <ShopManagementPageHero
          eyebrow="Shop Inbox"
          title="Messages"
          copy="Manage customer conversations and keep shop replies inside the seller workspace."
        />
        <DashboardMessages />
      </main>
    </div>
  </div>
  )
}

export default ShopInboxPage